import { Select, SelectProps } from '@mantine/core';
import { UserAlertDay } from '../../../../../backend/src/types.generated';

const REMINDER_DAY_OPTIONS = [
	{ value: UserAlertDay.Monday, label: 'Monday' },
	{ value: UserAlertDay.Tuesday, label: 'Tuesday' },
	{ value: UserAlertDay.Wednesday, label: 'Wednesday' },
	{ value: UserAlertDay.Thursday, label: 'Thursday' },
	{ value: UserAlertDay.Friday, label: 'Friday' },
	{ value: UserAlertDay.Saturday, label: 'Saturday' },
	{ value: UserAlertDay.Sunday, label: 'Sunday' },
];

export const ReminderDayInput = (props: SelectProps) => {
	return <Select data={REMINDER_DAY_OPTIONS} {...props} />;
};
